// Boş/çözümlenemeyen tarihler için sonlu sentinel'ler.
const EMPTY_BOTTOM = -1;
const EMPTY_TOP = Number.MAX_SAFE_INTEGER;

// Çeşitli tarih formatlarını (YYYY-MM-DD, DD.MM.YYYY, DD/MM/YYYY, MM.YYYY, yalnızca YYYY) karşılaştırılabilir tek bir sayıya çevirir.
// Boş/çözümlenemeyen değerler verilen sentinel'e düşer.
export const toSortableDate = (
  value: any,
  empty: number = EMPTY_BOTTOM,
): number => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return empty;
  }
  const s = String(value).trim();

  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/); // YYYY-MM-DD (ISO dahil)
  if (m) return Number(m[1]) * 10000 + Number(m[2]) * 100 + Number(m[3]);

  m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/); // DD.MM.YYYY
  if (m) return Number(m[3]) * 10000 + Number(m[2]) * 100 + Number(m[1]);

  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/); // DD/MM/YYYY
  if (m) return Number(m[3]) * 10000 + Number(m[2]) * 100 + Number(m[1]);

  m = s.match(/^(\d{1,2})\.(\d{4})$/); // MM.YYYY
  if (m) return Number(m[2]) * 10000 + Number(m[1]) * 100;

  m = s.match(/(\d{4})/); // metin içindeki ilk yıl (örn. yalnızca "2021")
  if (m) return Number(m[1]) * 10000;

  return empty;
};

/** Tarihe göre azalan (emptyTo="top" → boş tarih en üste) */
export const byDateDesc = (
  key: string,
  emptyTo: "top" | "bottom" = "bottom",
) => {
  const empty = emptyTo === "top" ? EMPTY_TOP : EMPTY_BOTTOM;
  return (a: any, b: any) =>
    toSortableDate(b?.[key], empty) - toSortableDate(a?.[key], empty);
};

/** Önce bitiş tarihi azalan (null/boş → en üstte), eşitse başlangıç tarihi azalan */
export const byEndThenStartDesc = (a: any, b: any) => {
  const byEnd = byDateDesc("endDate", "top")(a, b);
  return byEnd !== 0 ? byEnd : byDateDesc("startDate", "top")(a, b);
};

/** İş tecrübelerini en yakın zamandan eskiye (devam edenler en üstte) sıralar. */
export const sortWorkExperiencesByDate = <T,>(records: T[]): T[] => {
  if (!Array.isArray(records)) return records;
  return [...records].sort(byEndThenStartDesc);
};
